import { Action } from 'redux';
import * as actionTypes from 'shared/store/action-types';
import { RegisterModalState } from '../interface/registration';

const initialState: RegisterModalState = {
	registrationMethodModalOpen: false,
	step1RegisterModalOpen: false,
	step2RegisterModalOpen: false,
};

const reducer = (state: RegisterModalState = initialState, action: Action): RegisterModalState => {
	switch (action.type) {
		case actionTypes.SHOW_REGISTER_MODAL:
			return {
				...state,
				step1RegisterModalOpen: true,
			};
		case actionTypes.HIDE_REGISTER_MODAL:
			return {
				...state,
				step1RegisterModalOpen: false,
			};
		case actionTypes.SHOW_REGISTER_MODAL_STEP2:
			return {
				...state,
				step2RegisterModalOpen: true,
			};
		case actionTypes.HIDE_REGISTER_MODAL_STEP2:
			return {
				...state,
				step2RegisterModalOpen: false,
			};
		default:
			return state;
	}
};

export default reducer;
